// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitsPermitBtn_root__1LGsv"};